export default __webpack_public_path__ + "static/media/336D.a59e0c0b.pdf";